import React from 'react';

const SSTLogo = ({ className, width = "100%", height = "auto" }) => {
  return (
    <svg 
      className={className} 
      width={width} 
      height={height === "auto" ? undefined : height} 
      style={height === "auto" ? { height: "auto" } : undefined}
      viewBox="0 0 240 80" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Upper curve for "Sri Shiva Travels" */}
        <path id="upper-arc" d="M 12 40 a 28 28 0 0 1 56 0" />
        {/* Lower curve for "Timely & Trustworthy Transportation" */}
        <path id="lower-arc" d="M 70 40 a 30 30 0 0 1 -60 0" />
      </defs>

      {/* Emblem Background & Border */}
      <circle cx="40" cy="40" r="38" fill="#1F242C" stroke="#22B565" strokeWidth="2.5" />
      
      {/* Outer Circle Texts */}
      <text style={{ fontFamily: "'Times New Roman', Times, serif", fontSize: "11px", fontWeight: "700", fill: "#22B565" }}>
        <textPath href="#upper-arc" startOffset="50%" textAnchor="middle">
          Sri Shiva Travels
        </textPath>
      </text>
      
      <text style={{ fontFamily: "'Times New Roman', Times, serif", fontSize: "7.5px", fontWeight: "700", fill: "#22B565" }}>
        <textPath href="#lower-arc" startOffset="50%" textAnchor="middle">
          Timely &amp; Trustworthy Transportation
        </textPath>
      </text>

      {/* Separator dots */}
      <circle cx="12" cy="40" r="2.5" fill="#22B565" />
      <circle cx="68" cy="40" r="2.5" fill="#22B565" />
      
      {/* Inner Small SST */}
      <text style={{ fontFamily: "'Impact', 'Arial Black', sans-serif", fontSize: "18px", fontWeight: "900", fill: "#22B565", letterSpacing: "-0.5px" }} x="40" y="31" textAnchor="middle">SST</text>
      {/* Small swoosh over inner SST */}
      <path d="M 26 31 Q 40 24 53 28 L 53 29 Q 40 25 25 32 Z" fill="#FFFFFF" />
      <path d="M 26 31 Q 40 24 53 28 L 53 29 Q 40 25 25 32 Z" fill="#FFFFFF" stroke="#FFFFFF" strokeWidth="0.5" />
      
      {/* Center Car Icon */}
      <g transform="translate(29, 36)">
        {/* Taxi Sign */}
        <path d="M 9.5 0 h 3 v 2 h -3 z" fill="#22B565" />
        {/* Top cabin */}
        <path d="M 5 6 L 7 2 L 15 2 L 17 6 z" fill="none" stroke="#22B565" strokeWidth="1.5" strokeLinejoin="round" />
        {/* Main Body */}
        <path d="M 3 6 h 16 v 4 a 2 2 0 0 1 -2 2 h -12 a 2 2 0 0 1 -2 -2 z" fill="#22B565" />
        {/* Headlights */}
        <circle cx="6" cy="9" r="1.5" fill="#1F242C" />
        <circle cx="16" cy="9" r="1.5" fill="#1F242C" />
        
        {/* Checkered pattern under car */}
        <g fill="#22B565" transform="translate(0, 14)">
          <rect x="0" y="0" width="2" height="2" />
          <rect x="4" y="0" width="2" height="2" />
          <rect x="8" y="0" width="2" height="2" />
          <rect x="12" y="0" width="2" height="2" />
          <rect x="16" y="0" width="2" height="2" />
          <rect x="20" y="0" width="2" height="2" />
          
          <rect x="2" y="2" width="2" height="2" />
          <rect x="6" y="2" width="2" height="2" />
          <rect x="10" y="2" width="2" height="2" />
          <rect x="14" y="2" width="2" height="2" />
          <rect x="18" y="2" width="2" height="2" />
        </g>
      </g>

      {/* Right side large text */}
      <g transform="translate(85, 10)">
        <text style={{ fontFamily: "'Impact', 'Arial Black', sans-serif", fontSize: "58px", fontWeight: "900", fill: "#22B565", letterSpacing: "-1.5px" }} x="0" y="58">SST</text>
        {/* The swoosh mask for the large SST text */}
        <path d="M 2 58 Q 38 36 110 36 L 110 38 Q 38 39 0 61 Z" fill="#FFFFFF" />
      </g>
    </svg>
  );
};

export default SSTLogo;
